// AUTO-GENERATED by scripts/probe-images.js — do not edit by hand.
// Pixel-accurate intrinsic dimensions of every artwork image. Used to
// emit width/height attrs on <img> tags so layout is reserved before
// the image loads (zero CLS).
export const IMAGE_META = {
  "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/ik0xqx5o_016%20LR.jpg": {
    "w": 1125,
    "h": 938,
    "ar": 1.1994
  },
  "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/elqe1yil_001%20LR.jpg": {
    "w": 1125,
    "h": 844,
    "ar": 1.3329
  },
  "https://customer-assets.emergentagent.com/job_d1c1e8f3-af7e-4791-90a6-1b161090eb05/artifacts/s88km12u_Image.jpg": {
    "w": 1477,
    "h": 1179,
    "ar": 1.2528
  },
  "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/j4xpupqv_022%20LR.jpg": {
    "w": 1125,
    "h": 844,
    "ar": 1.3329
  },
  "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/5lzanghr_IMG_4638_zevhjr_upscaled.jpg": {
    "w": 4048,
    "h": 4096,
    "ar": 0.9883
  },
  "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/di3d5hq0_021%20LR.jpg": {
    "w": 1125,
    "h": 844,
    "ar": 1.3329
  },
  "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/05kwbpcd_IMG_6978.jpg": {
    "w": 3116,
    "h": 3166,
    "ar": 0.9842
  },
  "https://customer-assets.emergentagent.com/job_d1c1e8f3-af7e-4791-90a6-1b161090eb05/artifacts/mx24ysnx_IMG_4664_jsd4zw.jpeg": {
    "w": 3000,
    "h": 2940,
    "ar": 1.0204
  },
  "https://customer-assets.emergentagent.com/job_d1c1e8f3-af7e-4791-90a6-1b161090eb05/artifacts/aioxc45d_When%20The%20Light%20Stayed%2C%202025.jpg": {
    "w": 4004,
    "h": 4096,
    "ar": 0.9775
  },
  "https://customer-assets.emergentagent.com/job_d1c1e8f3-af7e-4791-90a6-1b161090eb05/artifacts/nl9wdoqo_014%20LR.jpg": {
    "w": 1125,
    "h": 788,
    "ar": 1.4277
  },
  "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/l2ui13ns_Arising%20from%20the%20Depths%2C%202025.jpg": {
    "w": 2763,
    "h": 2080,
    "ar": 1.3284
  },
  "https://customer-assets.emergentagent.com/job_d1c1e8f3-af7e-4791-90a6-1b161090eb05/artifacts/h3lzdgf8_002%20LR.jpg": {
    "w": 1125,
    "h": 788,
    "ar": 1.4277
  },
  "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/3fxejt5i_004%20LR.jpg": {
    "w": 1125,
    "h": 900,
    "ar": 1.25
  },
  "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/84lgt3md_f26e4800-290e-11f0-92b7-657dd8c29cf9_b8xbhv.jpeg": {
    "w": 2993,
    "h": 2217,
    "ar": 1.35
  },
  "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/72f8w6ku_003%20LR.jpg": {
    "w": 1125,
    "h": 900,
    "ar": 1.25
  },
  "https://customer-assets.emergentagent.com/job_d1c1e8f3-af7e-4791-90a6-1b161090eb05/artifacts/t44mi11x_IMG_6313_isnmhc.jpeg": {
    "w": 2999,
    "h": 3000,
    "ar": 0.9997
  },
  "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/g3n8zwsg_009%20LR.jpg": {
    "w": 844,
    "h": 1125,
    "ar": 0.7502
  },
  "https://customer-assets.emergentagent.com/job_d1c1e8f3-af7e-4791-90a6-1b161090eb05/artifacts/wy7myu0f_Screenshot%202026-04-18%20at%2022.29.37.png": {
    "w": 1170,
    "h": 1190,
    "ar": 0.9832
  },
  "https://customer-assets.emergentagent.com/job_d1c1e8f3-af7e-4791-90a6-1b161090eb05/artifacts/b5jr5snj_Screenshot%202026-05-20%20at%2022.18.50.png": {
    "w": 810,
    "h": 1070,
    "ar": 0.757
  },
  "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/205445g6_IMG_6314_ocoxux_upscaled.jpg": {
    "w": 4074,
    "h": 4096,
    "ar": 0.9946
  },
  "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/y1oqjvho_IMG_6971.jpg": {
    "w": 3127,
    "h": 3102,
    "ar": 1.0081
  },
  "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/cb6z9vcj_Bloom%20Against%20the%20Noise%2C%202025.jpg": {
    "w": 3563,
    "h": 3584,
    "ar": 0.9941
  },
  "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/8fr4qmvv_IMG_4141.jpg": {
    "w": 1245,
    "h": 884,
    "ar": 1.4084
  },
  "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/wjx2gey4_005%20LR.jpg": {
    "w": 1125,
    "h": 1125,
    "ar": 1
  },
  "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/2xx2583s_007%20LR.jpg": {
    "w": 844,
    "h": 1125,
    "ar": 0.7502
  },
  "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/hrn1t5s7_010%20LR.jpg": {
    "w": 1125,
    "h": 788,
    "ar": 1.4277
  },
  "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/xivjet9v_011%20LR.jpg": {
    "w": 788,
    "h": 1125,
    "ar": 0.7004
  },
  "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/sc8zrg9l_012%20LR.jpg": {
    "w": 1125,
    "h": 788,
    "ar": 1.4277
  },
  "https://customer-assets.emergentagent.com/job_d1c1e8f3-af7e-4791-90a6-1b161090eb05/artifacts/vrppf6ex_She%20Was%20the%20Mirror%2C%202025.jpg": {
    "w": 2401,
    "h": 3167,
    "ar": 0.7581
  },
  "https://customer-assets.emergentagent.com/job_d1c1e8f3-af7e-4791-90a6-1b161090eb05/artifacts/j2squ5xq_Screenshot%202026-04-18%20at%2022.33.11.png": {
    "w": 1428,
    "h": 1416,
    "ar": 1.0085
  },
  "https://customer-assets.emergentagent.com/job_d1c1e8f3-af7e-4791-90a6-1b161090eb05/artifacts/o925it3v_Screenshot%202026-04-18%20at%2022.33.42.png": {
    "w": 1392,
    "h": 1374,
    "ar": 1.0131
  },
  "https://customer-assets.emergentagent.com/job_d1c1e8f3-af7e-4791-90a6-1b161090eb05/artifacts/790ffmkw_Screenshot%202026-04-19%20at%2016.47.16.jpeg": {
    "w": 1034,
    "h": 1350,
    "ar": 0.7659
  },
  "https://customer-assets.emergentagent.com/job_d1c1e8f3-af7e-4791-90a6-1b161090eb05/artifacts/lj2jkghj_IMG_7040.jpg": {
    "w": 2677,
    "h": 3590,
    "ar": 0.7457
  },
  "https://customer-assets.emergentagent.com/job_d1c1e8f3-af7e-4791-90a6-1b161090eb05/artifacts/5iy12rox_IMG_7041.jpg": {
    "w": 2752,
    "h": 3632,
    "ar": 0.7577
  },
  "https://customer-assets.emergentagent.com/job_4c151c74-e5e5-488f-ba21-c2649708aa09/artifacts/1aul39xe_017%20HR.jpg": {
    "w": 4200,
    "h": 6000,
    "ar": 0.7
  },
  "https://customer-assets.emergentagent.com/job_d1c1e8f3-af7e-4791-90a6-1b161090eb05/artifacts/fieleifj_86937510-2918-11f0-92b7-657dd8c29cf9_op5rv8.jpeg": {
    "w": 2243,
    "h": 2696,
    "ar": 0.832
  },
  "/works/when-the-ocean-remembers-2025.jpg": {
    "w": 1800,
    "h": 1388,
    "ar": 1.2968
  },
  "/works/when-the-ocean-listens-2025.jpg": {
    "w": 1800,
    "h": 1347,
    "ar": 1.3363
  },
  "/works/when-the-ocean-looks-back-2025.jpg": {
    "w": 1800,
    "h": 1340,
    "ar": 1.3433
  },
  "/works/ashes-of-us-2025.jpg": {
    "w": 1626,
    "h": 1232,
    "ar": 1.3198
  },
  "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/bmuvwvy6_IMG_6978.jpg": {
    "w": 3116,
    "h": 3166,
    "ar": 0.9842
  },
  "https://customer-assets.emergentagent.com/job_b37c064b-36a6-4abb-ab84-e2dc4f75b0d9/artifacts/iv06lvn1_Screenshot%202026-05-21%20at%2016.24.01.png": {
    "w": 1272,
    "h": 1604,
    "ar": 0.793
  }
};
export const FALLBACK_AR = 1.3333;
export const arOf = (url) => (IMAGE_META[url] && IMAGE_META[url].ar) || FALLBACK_AR;
export const dimsOf = (url) => IMAGE_META[url] || null;
